import { ExternalLinks } from 'shared/enums/external-links.enum';
import { BrandExternalLinks, envConfig } from '../types';
import cloneDeep from 'lodash/cloneDeep';

const prod: envConfig = {
  api: 'https://api-front.umbrellacost.io',
  redirectURL: 'https://umbrellacost.io',
  legacyAPI: 'https://api.mypileus.io',
  keycloak: 'https://login.umbrellacost.io',
  cognitoPool: 'https://mypileus.auth.us-east-1.amazoncognito.com',
};

const staging: envConfig = {
  api: 'https://api.staging.umbrellacost.dev',
  redirectURL: 'https://staging.umbrellacost.dev',
  legacyAPI: 'https://api.staging.mypileus.io',
  keycloak: 'https://keycloak.dev.umbrellacost.dev',
  cognitoPool: 'https://dev-mypileus.auth.us-east-1.amazoncognito.com',
};

const dev: envConfig = {
  api: 'https://api.dev.umbrellacost.dev',
  redirectURL: 'https://dev.umbrellacost.dev',
  legacyAPI: 'https://api.dev.mypileus.io',
  keycloak: 'https://keycloak.dev.umbrellacost.dev',
  cognitoPool: 'https://dev-mypileus.auth.us-east-1.amazoncognito.com',
};

const feature: envConfig = {
  api: 'https://feature-frontend-frontend-app-server:8080',
  legacyAPI: 'https://feature-frontend-frontend-app-server:8080',
  redirectURL: 'https://feature.mypileus.io',
  keycloak: 'http://keycloak-http:80',
  cognitoPool: 'https://dev-mypileus.auth.us-east-1.amazoncognito.com',
};

const local: envConfig = {
  api: ExternalLinks.LocalHost,
  legacyAPI: 'https://f78f-199-203-250-201.ngrok-free.app',
  redirectURL: ExternalLinks.LocalServerURI,
};

const DefaultExternalLinks: BrandExternalLinks = {
  prod,
  staging,
  dev,
  feature,
  local,

  TermsAndConditions: 'https://umbrellacost.com/terms-of-use',
  PrivacyPolicy: 'https://umbrellacost.com/privacy-policy',
  ContactUs: 'https://umbrellacost.com/contact-us',

  AwsOnboardingCFTJson: 'https://pileus-cloudformation-public.s3.amazonaws.com/PileuseOnboardingCFT.json',

  ConnectYourLinkedAccounts: 'https://docs.umbrellacost.io/docs/connect-your-linked-accounts#/',
  SettingNonUSDCurrenciesForAccounts: 'https://docs.umbrellacost.io/docs/accounts-currency#/',
  ConnectAzureApplications: 'https://docs.umbrellacost.io/docs/connect-azure-applications#/',
  CueFilters: 'https://docs.umbrellacost.io/docs/understand-the-cost-usage-filters#/',
  RecommendationsForAWS: 'https://docs.umbrellacost.io/docs/recommendations-for-aws#/',
  RecommendationsForAzure: 'https://docs.umbrellacost.io/docs/azure-recommendations#/',
  RecommendationsForGCP: 'https://docs.umbrellacost.io/docs/recommendations-for-gcp#/',
  K8sWorkloadRightsizingRecommendation: 'https://docs.umbrellacost.io/docs/k8s-workload-rightsizing-recommendation#/',

  RecommendationsForAwsSectionRds: 'https://docs.umbrellacost.io/docs/recommendations-for-aws', // mick
  PrometheusAgentForKubernetesForAWSAzure:
    'https://docs.umbrellacost.io/docs/prometheus-agent-for-kubernetes-for-aws-azure#/',
  WorkingWithCostGPT: 'https://docs.umbrellacost.io/docs/costgpt#/',
  IntroductionToAWSCostMonitoring: 'https://docs.umbrellacost.io/docs/connecting-aws#/',
  PrerequisitesForOnboardingWithAzure: 'https://docs.umbrellacost.io/docs/prerequisites-for-onboarding#/',
  GcpOnboarding: 'https://docs.umbrellacost.io/docs/gcp-onboarding#/',
  DocumentationForResellers: 'https://docs.umbrellacost.io/docs/partner-overview#/',
  ForecastArchitecture: 'https://docs.umbrellacost.io/docs/forecast-architecture#/',
  AWSCustomerType: 'https://docs.umbrellacost.io/docs/aws-onboarding-for-msp#/',
  AutomaticAWSOnboardingType: 'https://docs.umbrellacost.io/docs/aws-automatic-onboarding#/',
  ManualAWSOnboardingType: 'https://docs.umbrellacost.io/docs/aws-manual-onboarding#/',
  AWSOnboardingLinkedAccountsAutomatic: 'https://docs.umbrellacost.io/docs/connect-your-linked-accounts#/',
  AWSOnboardingTypeEventNotification:
    'https://docs.umbrellacost.io/docs/aws-manual-onboarding#/create-event-notification',
  AzureOnboardingType: 'https://docs.umbrellacost.io/docs/azure-onboarding#/',
  AzureCustomerType: 'https://docs.umbrellacost.io/docs/azure-onboarding-for-msp#/',
  AzureFocusGuide: 'https://docs.umbrellacost.io/docs/migrate-azure-accounts-to-focus#/',
  GcpCustomerType: 'https://docs.umbrellacost.io/docs/gcp-onboarding-for-msp#/',
  GcpOnboardingType: 'https://docs.umbrellacost.io/docs/gcp-onboarding#/',
  GcpK8sIntegration: 'https://docs.umbrellacost.io/docs/how-to-connect-a-gcp-k8s-cluster#/',
  ByodOnboarding: 'https://docs.umbrellacost.io/docs/bring-your-own-data#/',
  SystemNotifications: 'https://docs.umbrellacost.io/docs/system-notifications#/',
  CostMainDashboard: 'https://docs.umbrellacost.io/docs/umbrella-cost-main-dashboard#/',
  RiUtilization: 'https://docs.umbrellacost.io/docs/ri-utilization#/',
  ConnectLinkedAccount:
    'https://docs.umbrellacost.io/docs/connect-your-linked-accounts#/manual-connection-for-each-linked-account-via-the-umbrella-cost-ui',
};

export const UmbrellaExternalLinks: BrandExternalLinks = {
  ...cloneDeep(DefaultExternalLinks),
  prod: {
    ...cloneDeep(DefaultExternalLinks.prod),
  },
  staging: {
    ...cloneDeep(DefaultExternalLinks.staging),
  },
  dev: {
    ...cloneDeep(DefaultExternalLinks.dev),
  },
};

export const OrganizationLearnMoreLinks = {
  Roles: 'https://docs.umbrellacost.io/docs/roles#/',
  Users: 'https://docs.umbrellacost.io/docs/users#/',
  CostCenters: 'https://docs.umbrellacost.io/docs/cost-centers#/',
  Customers: 'https://docs.umbrellacost.io/docs/customers#/',
  Permissions: 'https://docs.umbrellacost.io/docs/the-permission-list-table#/',
};
